<form [formGroup]="form" (change)="update()">
  <ng-container *ngFor="let control of languages">
    <mat-form-field floatLabel="always">
      <mat-label>{{ control.label | translate }}</mat-label>
      <input matInput type="text" [formControlName]="control.value" />
    </mat-form-field>
  </ng-container>
</form>
